<template>
  <!-- <transition name="el-fade-in-linear"> -->
    <div class="refresh-timer" v-if="currentTimer !== null">
      <div :class="['motion', isLoading ? 'is-loading' : 'normal']" @click="onClickRefreshBtn">
        <ul>
          <div class="figure">
            <span class="span"> {{ currentTimer }} </span>
            <div class="icon"></div>
          </div>
          <li></li>
          <li></li>
          <!-- 3번 li 지우면 아래도 지워주세요 -->
          <li></li>
        </ul>
      </div>
    </div>
  <!-- </transition> -->
</template>

<script>
import DashboardConst from '@/constants/dashboard';
import MapConst from '@/constants/topologymap';

export default {
  name: 'WRefreshTimer',
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentTimer: null,
      isLoading: false,
    };
  },
  created() {
    if (this.type === 'DASHBOARD') {
      this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.REFRESH_TIMER, this.updateTimer);
    }

    if (this.type === 'TOPOLOGYMAP') {
      this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.REFRESH_TIMER, this.updateTimer);
    }
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.REFRESH_TIMER, this.updateTimer);
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.REFRESH_TIMER, this.updateTimer);
  },
  methods: {
    updateTimer(time) {
      this.currentTimer = time;
      if (this.currentTimer === 0) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    },
    onClickRefreshBtn() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.$emit('refresh');
    },
  },
};
</script>

<style lang="scss">
.refresh-timer {
  @import 'src/assets/scss/_variable.scss';
  @import 'src/assets/scss/_mixin.scss';
  .motion {
    position: absolute;
    width: 50px;
    height: 50px;
    bottom: 15px;
    right: 15px;

    .figure {
      position: absolute;
      display: inline-block;
      font-size: $text-14;
      font-weight: bold;
      text-align: center;
      width: 36px;
      line-height: 36px;
      color: white;
      z-index: 22;

      // .span {
      //   font-size: $text-14;
      //   transition: .2s ease
      // }
    }
    &.normal:hover {
      cursor: pointer;
      .figure {
        .icon {
          &:before {
            @include fontawesome;
            content: '\f021';
            font-size: $text-medium;
          }
        }
        .span {
          display: none;
        }
      }
    }
    &.is-loading {
      cursor: normal;
      pointer-events: none;
      .figure {
        .icon {
          display: inline-block;
          position: relative;
          margin: 0px;
          padding: 0px;
          width: 100%;
          height: 100%;
          border-radius: 100px;
          opacity: 0.4;
          animation: icon-spin 2s infinite linear;
          @keyframes icon-spin{
            0%{transform: rotate(0deg);background: linear-gradient(90deg, #fe9000, #da2626)}
            100%{transform: rotate(360deg);background: linear-gradient(90deg, #fe9000, #da2626)}
          }
          &:before {
            @include fontawesome;
            content: '\f021';
            font-size: $text-medium;
          }
        }
        .span {
          display: none;
        }
      }
    }
    li{
      position: absolute;
      border: 1px solid rgba(254,144,0, 1.0);
      display: block;
      background: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-radius: 100px;
      transition: all 0.5s ease;
      animation: inner-spin 3s infinite linear;
      @keyframes inner-spin{
        0%{transform: rotate(0deg);background: linear-gradient(90deg, #fe9000, #da2626)}
        100%{transform: rotate(360deg);background: linear-gradient(90deg, #fe9000, #da2626)}
      }
    }
    li:last-child {
      z-index: 20;
      width: 36px;
      height: 36px;
      margin-left: 0;
      margin-top: 0;
      background: linear-gradient(90deg, #da2626, #fe9000);
      border: 1px solid #fe9000;
      border-radius: 46px;
      box-shadow: 0px 0px 7px rgba(254,144,0, 0.5);
      // &:after{
      //   content:'';
      //   border-radius: 46px;
      //   width: 46px;
      //   height: 46px;
      //   display: block;
      //   position: absolute;
      //   top:-1px;
      //   left:-1px;
      //   background-color: transparent;
      //   box-shadow: inset 0px 0px 10px rgba(0,0,0,0.2);
      // }
    }
    li:first-child{border-width: 0}
    li:nth-child(2){
      margin-left: -5px;
      margin-top: -5px;
      z-index: 1;
      width: 46px;
      height: 46px;
      border-width: 1px;
      // border-style: dotted;
      box-shadow: 0px 0px 4px rgba(254,144,0, .5);
      animation: spin1 4s infinite linear;
      @keyframes spin1{
        0%{transform: rotate(360deg);box-shadow: 0px 0px 3px rgba(254,144,0, 0.2)}
      }
    }
    // 과하면 3번은 지워주세요
    li:nth-child(3){
      margin-left: -11px;
      margin-top: -11px;
      z-index: 1;
      width: 58px;
      height: 58px;
      border-width: 1px;
      box-shadow: inset 0px 0px 4px rgba(255,144,0, .5);
      animation: spin2 5s infinite linear;
      @keyframes spin2{
        0%  {transform: rotate(0deg);}
        100%{transform: rotate(360deg);}
      }
    }
  }
}
.topologymap-panel .refresh-timer .motion {
  bottom: 15px;
  right: 35px;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/RefreshTimer.vue